import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

/**
 * Dropzone de upload (drag & drop + clique) com estado de "enviando" (ampulheta).
 * Componente puramente de UI: quem usa decide o que fazer com os arquivos
 * recebidos em (filesSelected) — upload, leitura, etc. — e controla [uploading].
 */
@Component({
  selector: 'app-file-dropzone',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './file-dropzone.component.html',
  styleUrl: './file-dropzone.component.css',
})
export class FileDropzoneComponent {
  /** Permite selecionar/soltar mais de um arquivo por vez. */
  @Input() multiple = true;
  /** Repassado ao <input type="file accept>. Ex.: ".csv", "image/*", ".pdf,.docx". */
  @Input() accept = '';
  /** Enquanto true, mostra o ícone/label de "enviando" e bloqueia novas seleções. */
  @Input() uploading = false;
  /** Bloqueia a dropzone (além do estado de uploading) — ex.: sem id do registro pai ainda. */
  @Input() disabled = false;

  @Input() icon = 'cloud_upload';
  @Input() label = 'Solte arquivos aqui ou clique para enviar';
  @Input() hint = '';

  @Input() uploadingIcon = 'hourglass_top';
  @Input() uploadingLabel = 'Enviando…';

  /** Emitido com os arquivos escolhidos (via clique ou drag&drop). */
  @Output() filesSelected = new EventEmitter<FileList>();

  @ViewChild('fileInput') private fileInput?: ElementRef<HTMLInputElement>;

  isDragOver = false;

  get isBlocked(): boolean {
    return this.uploading || this.disabled;
  }

  onDropzoneClick(): void {
    if (this.isBlocked) return;
    this.fileInput?.nativeElement.click();
  }

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    if (this.isBlocked) return;
    this.isDragOver = true;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

  onFilesDropped(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    if (this.isBlocked) return;
    const files = event.dataTransfer?.files;
    if (files?.length) this.filesSelected.emit(files);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) this.filesSelected.emit(input.files);
    input.value = '';
  }
}
